// extracted by mini-css-extract-plugin
export default {"change-modal":"ChangeModal_change-modal__Q3nZU"};